import {
	FormAsyncSelectField,
	FormAsyncSelectFieldProps,
} from "src/components/common/forms/fields/FormAsyncSelectField.tsx";
import { AppUser } from "src/api/generated/postgres/db/types/role_management/tables/appUser.ts";
import { UserApi } from "src/api/generated/users/api/userApi.ts";
import { PartialBy } from "src/utils/partialBy.ts";

export interface FormAsyncUserSelectFieldProps<TFieldValues extends object>
	extends PartialBy<
		FormAsyncSelectFieldProps<TFieldValues, AppUser, number>,
		"fetchOptions" | "getOptionKey" | "getOptionLabel"
	> {}

export const FormAsyncUserSelectField = <TFieldValues extends object>({
	...other
}: FormAsyncUserSelectFieldProps<TFieldValues>) => {
	return (
		<FormAsyncSelectField<TFieldValues, AppUser, number>
			fetchOptions={({ searchQuery, currentSelection }) =>
				UserApi.getUserSelectionOptions({
					searchQuery: searchQuery,
					currentSelectionUserId: currentSelection,
				})
			}
			getOptionKey={(option) => option.id}
			getOptionLabel={(option) => option.name}
			{...other}
		/>
	);
};
